import React from "react";
import classes from "./Button.module.scss";
import { ButtonProps } from "./types";

export const Button: React.FC<ButtonProps> =
  ({
     children,
     rounded,
     className = '',
     variant = 'primary',
     href,
     ...props
   }) => {
    if (variant === 'link') {
      return (
        <a
          href={href}
          {...props}
          className={`
          ${classes.link} 
          ${classes.button} 
          ${rounded ? classes.rounded : ''} 
          ${className}`
          }
        >
          { children }
        </a>
      )
    }

    return (
      <button
        {...props}
        className={`
        ${classes.button} 
        ${classes[variant]} 
        ${rounded ? classes.rounded : ''} 
        ${className}`
        }
      >
        { children }
      </button>
    );
  }